// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"31e3fe11","419":"a2684093","563":"ba15ce90","942":"953e35bc"}[chunkId] + ".chunk.js";
};